import { Component, ViewChild } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { DashboardService } from '../../Model/Dashboard/dashboard.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UtilityService } from '../../Model/utility/utility.service';
import moment from 'moment';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { NgSelectModule } from '@ng-select/ng-select';
import * as XLSX from 'xlsx';
import { SessionService } from '../../Util/Session/session.service';
import { NgbDatepickerModule, NgbDropdownModule, NgbDateParserFormatter, NgbCollapse, NgbCollapseModule, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { never, Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';
import { CardDetailComponent } from '../CardDetail/card-detail/card-detail.component';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import * as pako from 'pako';
import { Tooltip } from 'chart.js';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { Router } from '@angular/router';
import { UserRightService } from '../../Model/UserRight/user-right.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, NgChartsModule, DataTablesModule, FormsModule, NgbDatepickerModule, NgbDropdownModule, DecimalPipe, NgSelectModule, NgbCollapseModule, LoaderComponent, NgbTooltip],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})

export class DashboardComponent {
  isDisabled: boolean = false;
  isApply: boolean = false;
  isGrouping: boolean = false;
  rowAttendanceData = [];
  rowAttendanceDataMain = [];
  rowAttendanceDataEmpMain = [];
  rowAttendanceDataEmp = [];
  branchSummary = [{
    BranchID: 0,
    Branch: null,
    TotalManpower: 0,
    TotalPunch: 0,
    TotalPending: 0,
    TotalActiveEmployeeCount: 0,
    Site: 0,
    Punch: 0,
    Pending: 0,
  }];
  filterData = [] as any;
  filterEmpData = [] as any;
  excelData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  dtTriggerEmp: Subject<any> = new Subject<any>();
  dtTriggerSummaryDetail: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  @ViewChild(DataTableDirective, { static: false }) dtElementEmp!: DataTableDirective;
  @ViewChild(DataTableDirective, { static: false }) dtElementSummaryDetail!: DataTableDirective;


  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 25,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
  };
  dtOptionsEmp: DataTables.Settings = {}
  dtOptionsSummaryDetail: DataTables.Settings = {
    searching: false,
    paging: false
  }

  ShiftGroups = [] as any;
  Shifts = [] as any;
  // States = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  IndustrySegments = [] as any;
  SiteOwners = [] as any;
  // Zones = [] as any;
  Regions = [] as any;
  //Designations = [] as any;
  //Departments = [] as any;

  ShiftGroupsMap = new Map();
  ShiftsMap = new Map();
  //const StatesMap = new Map();
  BranchsMap = new Map();
  ClientsMap = new Map();
  IndustrySegmentsMap = new Map();
  SiteOwnersMap = new Map();
  SitesMap = new Map();
  //const ZonesMap = new Map();
  RegionsMap = new Map();

  LoadFlag = {
    BranchGraph: false,
    Analytics: false,
  }
  chartHeight = '400px';
  //chart dummy data-start

  // public TestChartData: ChartConfiguration<'doughnut'>['data'] = {
  //   labels: [
  //     'Present',
  //     'Absent',
  //   ],
  //   datasets: [
  //     {
  //       data: [75, 25],
  //       backgroundColor: [
  //         '#00d68f', '#FF0000',
  //       ],
  //     },
  //   ]
  // };

  // public CardChartData: ChartConfiguration<'doughnut'>['data'] = {
  //   labels: ["Purple",""],
  //   datasets: [{
  //     label: '# of Votes',
  //     data: [70,30],
  //     backgroundColor: [
  //       '#00d68f','#FF0000'
  //     ],
  //     borderColor: [
  //       '#00d68f','#FF0000'
  //     ],
  //     borderWidth: 2
  //   }],
  // };

  public BranchChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: []
    }],
  };

  public AttendanceChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: []
    // labels: [
    //   'Site 1',
    //   'Site 2',
    //   'Site 3',
    // ],
    // datasets: [{
    //   label: 'Total',
    //   data: [100, 60, 50],
    //   backgroundColor: [
    //     '#3f51b5',
    //   ],
    // },{
    //   label: 'Present',
    //   data: [60, 50, 20],
    //   backgroundColor: [
    //     '#00d68f',
    //   ],
    // },
    // {
    //   label: 'Absent',
    //   data: [40, 10, 30],
    //   backgroundColor: [
    //     '#ff3d71',
    //   ],
    // }]
  };

  ChartLegend = {
    Attendance: true,
    Branch: true,
  }

  Collapsed = {
    BranchGraph: false,
    AttendanceGraph: false,
    AttendanceAnalytics: false,
    EmployeeDetails: false,
    SummaryDetails: false,
  }

  summaryResponse = null as any;
  detailResponse = null as any;
  allowRedirectDevice = false;

  constructor(
    private dashboard: DashboardService,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    public datepipe: DatePipe,
    private session: SessionService,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private router: Router,
    private userright: UserRightService,
  ) {
    this.common.getPageRights();
    this.common.CompanyParameter();
    if (window.innerWidth < 768) {
      this.chartHeight = '500px';
    } else if (window.innerWidth < 992) {
      this.chartHeight = '550px';
    } else {
      this.chartHeight = '400px';
    }
  }

  mfilter = {
    TodayDate: null as any,
    filterType: 3,
    FromDate: null as any,
    ToDate: null as any,
    YesterdateDate: null as any,
    ShiftGroupMasterID: [] as any,
    ShiftMasterID: [] as any,
    StateMasterID: [] as any,
    BranchMasterID: [] as any,
    ClientGroupMasterID: [] as any,
    SiteMasterID: [] as any,
    IndustrySegmentId: [] as any,
    SiteOwnerID: [] as any,
    ZoneID: [] as any,
    RegionMasterID: [] as any,
    DesignationID: [] as any,
    DepartmentID: [] as any,
    EmpDataLoad: false,
  }

  filter = {
    MonthYear: null as any,
    FromDate: null as any,//'01 Feb 2024' 
    ToDate: null as any,//'27 Feb 2024'
    UserId: null,
    Type: 'SiteWise'
  }

  Card = {
    Total: 0,
    TotalActive: 0,
    Present: 0,
    PresentPer: 0 as any,
    Absent: 0,
    AbsentPer: 0 as any,
    Leave: 0,
    Holiday: 0,
    OnlineAttendance: 0,
    OnlineAttendancePer: 0 as any,
    WO: 0,
    WOPer: 0 as any,
  }

  groupby = {
    State: true,
    Region: true,
    Branch: true,
    Client: true,
    Site: true,
    Department: true,
    Designation: true,
    Supervisor: true,
    Checkall: true,
  }

  ngOnInit() {
    this.filter.UserId = this.session.GetUserDetails().UserId;
    this.SelectDate('RegistrationDate', null, null);
    this.AllowRedirectOnDeivce();
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.dtTriggerEmp.next(null);
    this.dtTriggerSummaryDetail.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.dtTriggerEmp.unsubscribe();
    this.dtTriggerSummaryDetail.unsubscribe();
  }

  FetchData() {
    this.summaryResponse = null;
    this.detailResponse = null;
    if (this.mfilter.filterType == 0 || this.mfilter.filterType == 3) {
      this.SelectDate('RegistrationDate', null, null);
    } else {
      this.AttendanceDashboardGetData();
    }
  }

  AttendanceDashboardGetData() {
    if (this.mfilter.filterType != 2 || (this.mfilter.filterType == 2 && (moment(this.dateFormate.format(this.mfilter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.mfilter.FromDate), 'DD MMM YYYY'))))) {
      this.isDisabled = true;
      this.isApply = true;
      this.isGrouping = true;
      this.mfilter.EmpDataLoad = false;
      this.rowAttendanceData = [];
      this.rowAttendanceDataMain = [];
      this.filterData = [] as any;
      this.filterEmpData = [] as any;

      this.filterData = Object.values([]);
      try {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
          this.dtTriggerEmp.next(null);
        });
      } catch (e) { }

      if (this.mfilter.filterType == 0) {
        this.mfilter.FromDate = {
          "year": this.mfilter.TodayDate.year(),
          "month": this.mfilter.TodayDate.month() + 1,
          "day": this.mfilter.TodayDate.date()
        };
        this.mfilter.ToDate = {
          "year": this.mfilter.TodayDate.year(),
          "month": this.mfilter.TodayDate.month() + 1,
          "day": this.mfilter.TodayDate.date()
        };
      } else if (this.mfilter.filterType == 3) {
        this.mfilter.FromDate = {
          "year": this.mfilter.YesterdateDate.year(),
          "month": this.mfilter.YesterdateDate.month() + 1,
          "day": this.mfilter.YesterdateDate.date()
        };
        this.mfilter.ToDate = {
          "year": this.mfilter.YesterdateDate.year(),
          "month": this.mfilter.YesterdateDate.month() + 1,
          "day": this.mfilter.YesterdateDate.date()
        };
      }

      if (this.mfilter.filterType == 1) {
        this.filter.MonthYear = this.dateFormate.fullmonth[this.mfilter.FromDate.month - 1] + ' ' + this.mfilter.FromDate.year;
        this.filter.FromDate = null;
        this.filter.ToDate = null;
      } else if (this.mfilter.filterType == 0 || this.mfilter.filterType == 2 || this.mfilter.filterType == 3) {
        this.filter.MonthYear = null;
        this.filter.FromDate = this.dateFormate.format(this.mfilter.FromDate);
        this.filter.ToDate = this.dateFormate.format(this.mfilter.ToDate);
      } else if (this.mfilter.filterType == 4) {
        this.filter.MonthYear = null;
        this.filter.FromDate = this.dateFormate.format(this.mfilter.ToDate);
        this.filter.ToDate = this.dateFormate.format(this.mfilter.ToDate);
      }

      try {
        this.dashboard.AttendanceDashboardGzipGetData(this.filter).subscribe({
          next: (response) => {
            try {
              this.summaryResponse = response;
              const compressedData = Uint8Array.from(atob(this.summaryResponse), c => c.charCodeAt(0));
              // Decompress the Gzip data
              const decompressedData = pako.inflate(compressedData, { to: 'string' });
              if (JSON.parse(decompressedData).Table.length > 0) {
                this.rowAttendanceDataMain = JSON.parse(decompressedData).Table;
                this.ShiftGroups = [];
                this.Shifts = [];
                //this.States = [];
                this.Branchs = [];
                this.Clients = [];
                this.IndustrySegments = [];
                this.SiteOwners = [];
                this.Sites = [];
                //this.Zones = [];
                this.Regions = [];
                //this.Designations = [];
                //this.Departments = [];
                this.branchSummary = [];


                this.ShiftGroupsMap = new Map();
                this.ShiftsMap = new Map();
                //const StatesMap = new Map();
                this.BranchsMap = new Map();
                this.ClientsMap = new Map();
                this.IndustrySegmentsMap = new Map();
                this.SiteOwnersMap = new Map();
                this.SitesMap = new Map();
                //const ZonesMap = new Map();
                this.RegionsMap = new Map();

                this.rowAttendanceDataMain.forEach((item: any) => {
                  if (item.ESS_ShiftGroupMasterId != null && !this.ShiftGroupsMap.has(item.ESS_ShiftGroupMasterId)) {
                    this.ShiftGroupsMap.set(item.ESS_ShiftGroupMasterId, item.ShiftGroupName);
                  }

                  if (item.ShiftId != null && !this.ShiftsMap.has(item.ShiftId)) {
                    try {
                      if (item.ShiftInTime != undefined && item.ShiftInTime != null && item.ShiftInTime != '') {
                        this.ShiftsMap.set(item.ShiftId, {
                          ShiftTitle: item.ShiftTitle, ShiftInTime: item.ShiftInTime,
                          ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.ShiftId == item.ShiftId).map((e: any) => e.ESS_ShiftGroupMasterId)))
                        });
                      } else {
                        this.ShiftsMap.set(item.ShiftId, {
                          ShiftTitle: item.ShiftTitle, ShiftInTime: '',
                          ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.ShiftId == item.ShiftId).map((e: any) => e.ESS_ShiftGroupMasterId)))
                        });
                      }
                    } catch (e) {
                      this.ShiftsMap.set(item.ShiftId, {
                        ShiftTitle: item.ShiftTitle, ShiftInTime: '',
                        ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.ShiftId == item.ShiftId).map((e: any) => e.ESS_ShiftGroupMasterId)))
                      });
                    }
                  }

                  // if (item.StateId != null && !StatesMap.has(item.StateId)) {
                  //   StatesMap.set(item.StateId, item.StateName);
                  // }

                  if (item.BranchId != null && !this.BranchsMap.has(item.BranchId)) {
                    this.BranchsMap.set(item.BranchId, {
                      BranchName: item.BranchName,
                      RegionMasterID: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.BranchId == item.BranchId).map((e: any) => e.RegionMasterID))),
                      ShiftId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.BranchId == item.BranchId).map((e: any) => e.ShiftId))),
                      ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.BranchId == item.BranchId).map((e: any) => e.ESS_ShiftGroupMasterId)))
                    });
                  }

                  if (item.ClientId != null && !this.ClientsMap.has(item.ClientId)) {
                    this.ClientsMap.set(item.ClientId, {
                      ClientName: item.ClientName,
                      BranchId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.ClientId == item.ClientId).map((e: any) => e.BranchId))),
                      RegionMasterID: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.ClientId == item.ClientId).map((e: any) => e.RegionMasterID))),
                      ShiftId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.ClientId == item.ClientId).map((e: any) => e.ShiftId))),
                      ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.ClientId == item.ClientId).map((e: any) => e.ESS_ShiftGroupMasterId))),
                    });
                  }

                  if (item.IndustrySegmentId != null && !this.IndustrySegmentsMap.has(item.IndustrySegmentId)) {
                    this.IndustrySegmentsMap.set(item.IndustrySegmentId, {
                      IndustrySegmentName: item.IndustrySegmentName,
                      SiteId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.IndustrySegmentId == item.IndustrySegmentId).map((e: any) => e.SiteId))),
                      ClientId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.IndustrySegmentId == item.IndustrySegmentId).map((e: any) => e.ClientId))),
                      BranchId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.IndustrySegmentId == item.IndustrySegmentId).map((e: any) => e.BranchId))),
                      RegionMasterID: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.IndustrySegmentId == item.IndustrySegmentId).map((e: any) => e.RegionMasterID))),
                      ShiftId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.IndustrySegmentId == item.IndustrySegmentId).map((e: any) => e.ShiftId))),
                      ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.IndustrySegmentId == item.IndustrySegmentId).map((e: any) => e.ESS_ShiftGroupMasterId)))
                    });
                  }

                  if (item.SiteSupervisorId != null && !this.SiteOwnersMap.has(item.SiteSupervisorId)) {
                    this.SiteOwnersMap.set(item.SiteSupervisorId, {
                      SiteSupervisorName: item.SiteSupervisorName,
                      SiteId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == item.SiteSupervisorId).map((e: any) => e.SiteId))),
                      ClientId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == item.SiteSupervisorId).map((e: any) => e.ClientId))),
                      BranchId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == item.SiteSupervisorId).map((e: any) => e.BranchId))),
                      RegionMasterID: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == item.SiteSupervisorId).map((e: any) => e.RegionMasterID))),
                      ShiftId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == item.SiteSupervisorId).map((e: any) => e.ShiftId))),
                      ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == item.SiteSupervisorId).map((e: any) => e.ESS_ShiftGroupMasterId)))
                    });
                  }

                  if (item.SiteId != null && !this.SitesMap.has(item.SiteId)) {
                    this.SitesMap.set(item.SiteId, {
                      SiteName: item.SiteName,
                      ClientId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteId == item.SiteId).map((e: any) => e.ClientId))),
                      BranchId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteId == item.SiteId).map((e: any) => e.BranchId))),
                      RegionMasterID: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteId == item.SiteId).map((e: any) => e.RegionMasterID))),
                      ShiftId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteId == item.SiteId).map((e: any) => e.ShiftId))),
                      ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.SiteId == item.SiteId).map((e: any) => e.ESS_ShiftGroupMasterId)))
                    });
                  }

                  // if (item.ZoneId != null && !ZonesMap.has(item.ZoneId)) {
                  //   ZonesMap.set(item.ZoneId, item.ZoneName);
                  // }
                  if (item.RegionMasterID != null && !this.RegionsMap.has(item.RegionMasterID)) {
                    this.RegionsMap.set(item.RegionMasterID, {
                      RegionName: item.RegionName,
                      ShiftId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.RegionMasterID == item.RegionMasterID).map((e: any) => e.ShiftId))),
                      ESS_ShiftGroupMasterId: Array.from(new Set(this.rowAttendanceDataMain.filter((e: any) => e.RegionMasterID == item.RegionMasterID).map((e: any) => e.ESS_ShiftGroupMasterId)))
                    });
                  }
                });

                this.ShiftGroupsMap.forEach((shiftGroupName, shiftGroupMasterId) => {
                  this.ShiftGroups.push({
                    ShiftGroupMasterID: shiftGroupMasterId,
                    ShiftGroupName: shiftGroupName,
                  });
                });

                this.ShiftsMap.forEach((shiftData, shiftId) => {
                  this.Shifts.push({
                    ShiftMasterID: shiftId,
                    ShiftTitle: shiftData.ShiftTitle,
                    ShiftInTime: shiftData.ShiftInTime
                  });
                });
                this.Shifts.sort((a: any, b: any) => {
                  const timeA = this.timeToMinutes(a.ShiftInTime);
                  const timeB = this.timeToMinutes(b.ShiftInTime);

                  return timeA - timeB;
                });

                //this.sortShiftsByStartTime();
                //console.log('Sorted shift data', this.Shifts);
                // StatesMap.forEach((stateName, stateId) => {
                //   this.States.push({
                //     StateMasterID: stateId,
                //     StateName: stateName
                //   });
                // });

                this.BranchsMap.forEach((branchData, branchId) => {
                  this.Branchs.push({
                    BranchMasterID: branchId,
                    BranchName: branchData.BranchName
                  });

                  this.branchSummary.push({
                    BranchID: branchId,
                    Branch: branchData.BranchName,
                    TotalManpower: this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId).map((e: any) => e.TotalManpowerOfSite).reduce((acc: any, cur: any) => acc + cur, 0),
                    TotalPunch: this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId).map((e: any) => e.P).reduce((acc: any, cur: any) => acc + cur, 0),
                    TotalPending: (this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId).map((e: any) => e.TotalManpowerOfSite).reduce((acc: any, cur: any) => acc + cur, 0)) - (this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId && e.P > 0).map((e: any) => e.P).reduce((acc: any, cur: any) => acc + cur, 0)),
                    TotalActiveEmployeeCount: this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId)[0]['TotalActiveEmployeeCount'],
                    Site: [...new Set(this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId).map((e: any) => e.SiteId))].length,
                    Punch: [...new Set(this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId && e.P > 0).map((e: any) => e.SiteId))].length,
                    Pending: [...new Set(this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId).map((e: any) => e.SiteId))].length - [...new Set(this.rowAttendanceDataMain.filter((e: any) => e.BranchId == branchId && e.P > 0).map((e: any) => e.SiteId))].length,
                  })
                });

                // this.dtElementSummaryDetail.dtInstance.then((dtInstanceSM: DataTables.Api) => {
                //   dtInstanceSM.destroy();
                //   this.dtTriggerSummaryDetail.next(null);
                // });

                this.ClientsMap.forEach((clientData, clientId) => {
                  this.Clients.push({
                    ClientGroupMasterID: clientId,
                    ClientGroupName: clientData.ClientName
                  });
                });

                this.IndustrySegmentsMap.forEach((industrySegmentData, industrySegmentId) => {
                  this.IndustrySegments.push({
                    IndustrySegmentId: industrySegmentId,
                    IndustrySegmentName: industrySegmentData.IndustrySegmentName
                  });
                });

                this.SiteOwnersMap.forEach((siteSupervisorData, siteSupervisorId) => {
                  this.SiteOwners.push({
                    SiteOwnerID: siteSupervisorId,
                    SiteOwnerName: siteSupervisorData.SiteSupervisorName
                  });
                });

                this.SitesMap.forEach((siteData, siteId) => {
                  this.Sites.push({
                    SiteMasterID: siteId,
                    SiteName: siteData.SiteName
                  });
                });

                // ZonesMap.forEach((zoneName, zoneId) => {
                //   this.Zones.push({
                //     ZoneID: zoneId,
                //     ZoneName: zoneName
                //   });
                // });

                this.RegionsMap.forEach((regionData, regionMasterID) => {
                  this.Regions.push({
                    RegionMasterID: regionMasterID,
                    RegionName: regionData.RegionName
                  });
                });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.ShiftId))].filter(e => e != null).forEach(element => {
                //   this.Shifts.push({
                //     ShiftMasterID: element,
                //     ShiftTitle: this.rowAttendanceDataMain.filter((e: any) => e.ShiftId == element)[0]['ShiftTitle']
                //   })
                // }); 

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.StateId))].filter(e => e != null).forEach(element => {
                //   this.States.push({
                //     StateMasterID: element,
                //     StateName: this.rowAttendanceDataMain.filter((e: any) => e.StateId == element)[0]['StateName']
                //   })
                // });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.BranchId))].filter(e => e != null).forEach(element => {
                //   this.Branchs.push({
                //     BranchMasterID: element,
                //     BranchName: this.rowAttendanceDataMain.filter((e: any) => e.BranchId == element)[0]['BranchName']
                //   })
                // });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.ClientId))].filter(e => e != null).forEach(element => {
                //   this.Clients.push({
                //     ClientGroupMasterID: element,
                //     ClientGroupName: this.rowAttendanceDataMain.filter((e: any) => e.ClientId == element)[0]['ClientName']
                //   })
                // });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.IndustrySegmentId))].filter(e => e != null).forEach(element => {
                //   this.IndustrySegments.push({
                //     IndustrySegmentId: element,
                //     IndustrySegmentName: this.rowAttendanceDataMain.filter((e: any) => e.IndustrySegmentId == element)[0]['IndustrySegmentId']
                //   })
                // });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.SiteSupervisorId))].filter(e => e != null).forEach(element => {
                //   this.SiteOwners.push({
                //     SiteOwnerID: element,
                //     SiteOwnerName: this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == element)[0]['SiteSupervisorName']
                //   })
                // });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.SiteId))].filter(e => e != null).forEach(element => {
                //   this.Sites.push({
                //     SiteMasterID: element,
                //     SiteName: this.rowAttendanceDataMain.filter((e: any) => e.SiteId == element)[0]['SiteName']
                //   })
                // });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.ZoneId))].filter(e => e != null).forEach(element => {
                //   this.Zones.push({
                //     ZoneID: element,
                //     ZoneName: this.rowAttendanceDataMain.filter((e: any) => e.ZoneId == element)[0]['ZoneName']
                //   })
                // });

                // [...new Set(this.rowAttendanceDataMain.map((item: any) => item.RegionMasterID))].filter(e => e != null).forEach(element => {
                //   this.Regions.push({
                //     RegionMasterID: element,
                //     RegionName: this.rowAttendanceDataMain.filter((e: any) => e.RegionMasterID == element)[0]['RegionName']
                //   })
                // });
                this.FilterForm();
              }
              this.isDisabled = false;
              this.isGrouping = false;
              this.isApply = false;
            } catch (e) {
              this.isDisabled = false;
              this.isGrouping = false;
              this.isApply = false;
            }
          },
          complete: () => {
            this.isDisabled = false;
            this.AttendanceDashboardGetDataEmp();
          },
          error: (error) => {
            console.log(error);
            this.isDisabled = false;
            this.isGrouping = false;
            this.isApply = false;
          },
        });
      } catch (e) {
        this.isDisabled = false;
        this.isGrouping = false;
        this.isApply = false;
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }
  // extractStartTime(shiftTitle: string): number {
  //   const timeParts = shiftTitle.split(' To ')[0];  
  //   const [hours, minutes] = timeParts.split(':').map(Number);  
  //   return hours * 60 + minutes;  
  // }
  // sortShiftsByStartTime(): void {
  //   this.Shifts.sort((a: { ShiftTitle: string; }, b: { ShiftTitle: string; }) => {
  //     const startTimeA = this.extractStartTime(a.ShiftTitle);
  //     const startTimeB = this.extractStartTime(b.ShiftTitle);
  //     return startTimeA - startTimeB;  
  //   });
  // }
  async FilterForm() {
    this.isDisabled = true;
    await new Promise(f => setTimeout(f, 500));
    this.Collapsed = {
      BranchGraph: false,
      AttendanceGraph: false,
      AttendanceAnalytics: false,
      EmployeeDetails: false,
      SummaryDetails: false,
    }

    this.LoadFlag = {
      BranchGraph: false,
      Analytics: false,
    }

    try {
      this.filterEmpData = []
      this.isApply = true

      //this.rowAttendanceData = this.rowAttendanceDataMain;
      this.rowAttendanceData = JSON.parse(pako.inflate(Uint8Array.from(atob(this.summaryResponse), c => c.charCodeAt(0)), { to: 'string' })).Table.filter((e: never) =>
        (this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.indexOf(e['ESS_ShiftGroupMasterId']) >= 0) &&
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftId']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateId']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchId']) >= 0) &&
        (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.indexOf(e['ClientId']) >= 0) &&
        (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.indexOf(e['SiteId']) >= 0) &&
        (this.mfilter.IndustrySegmentId.length == 0 || this.mfilter.IndustrySegmentId.indexOf(e['IndustrySegmentId']) >= 0) &&
        (this.mfilter.SiteOwnerID.length == 0 || this.mfilter.SiteOwnerID.indexOf(e['SiteSupervisorId']) >= 0) &&
        (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.indexOf(e['ZoneId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0));
      // this.rowAttendanceData = this.rowAttendanceDataMain.filter(e =>
      //   (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftId']) >= 0) &&
      //   (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateId']) >= 0) &&
      //   (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchId']) >= 0) &&
      //   (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.indexOf(e['ClientId']) >= 0) &&
      //   (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.indexOf(e['SiteId']) >= 0) &&
      //   (this.mfilter.IndustrySegmentId.length == 0 || this.mfilter.IndustrySegmentId.indexOf(e['IndustrySegmentId']) >= 0) &&
      //   (this.mfilter.SiteOwnerID.length == 0 || this.mfilter.SiteOwnerID.indexOf(e['SiteSupervisorId']) >= 0) &&
      //   (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.indexOf(e['ZoneId']) >= 0) &&
      //   (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0));

      this.Card.Total = this.rowAttendanceData.map((e: any) => e.TotalManpowerOfSite).reduce((acc, cur) => acc + cur, 0) + this.rowAttendanceData.filter((e: any) => e.TotalManpowerOfSite == 0 || e.TotalManpowerOfSite == null || e.TotalManpowerOfSite == '').map((e: any) => e.P).reduce((acc, cur) => acc + cur, 0);
      if (isNaN(this.Card.Total)) {
        this.Card.Total = 0;
      }

      this.Card.TotalActive = 0;
      if (this.mfilter.BranchMasterID == null || this.mfilter.BranchMasterID == '' || this.mfilter.BranchMasterID.length == 0) {
        this.Branchs.forEach((element: any) => {
          this.Card.TotalActive += parseInt(this.branchSummary.filter(e => e.BranchID == element.BranchMasterID)[0].TotalActiveEmployeeCount.toString());
        });
      } else {
        this.mfilter.BranchMasterID.forEach((element: any) => {
          this.Card.TotalActive += parseInt(this.branchSummary.filter(e => e.BranchID == element)[0].TotalActiveEmployeeCount.toString());
        });
      }

      if (isNaN(this.Card.TotalActive)) {
        this.Card.TotalActive = 0;
      }

      //this.Card.Present = this.rowAttendanceData.filter((e: any) => e.TotalManpowerOfSite > 0).map((e: any) => e.P).reduce((acc, cur) => acc + cur, 0);
      this.Card.Present = this.rowAttendanceData.map((e: any) => e.P).reduce((acc, cur) => acc + cur, 0);
      this.Card.PresentPer = ((this.Card.Present * 100) / this.Card.Total).toFixed(2);
      if (isNaN(this.Card.PresentPer)) {
        this.Card.PresentPer = 0;
      }
      //this.Card.Absent = this.rowAttendanceData.filter((e: any) => e.TotalManpowerOfSite > 0).map((e: any) => e.A).reduce((acc, cur) => acc + cur, 0);
      // this.Card.Absent = this.rowAttendanceData.map((e: any) => e.A).reduce((acc, cur) => acc + cur, 0);
      // this.Card.AbsentPer = ((this.Card.Absent * 100) / this.Card.Total).toFixed(2);
      // if (isNaN(this.Card.AbsentPer)) {
      //   this.Card.AbsentPer = 0;
      // }

      //this.Card.WO = this.rowAttendanceData.filter((e: any) => e.TotalManpowerOfSite > 0).map((e: any) => e.WO).reduce((acc, cur) => acc + cur, 0);
      this.Card.WO = this.rowAttendanceData.map((e: any) => e.WO).reduce((acc, cur) => acc + cur, 0);
      this.Card.WOPer = ((this.Card.WO * 100) / this.Card.Total).toFixed(2);
      if (isNaN(this.Card.WOPer)) {
        this.Card.WOPer = 0;
      }
      //this.Card.OnlineAttendance = this.rowAttendanceData.filter((e: any) => e.TotalManpowerOfSite > 0).map((e: any) => e.IsOnlineAttendance).reduce((acc, cur) => acc + cur, 0);
      this.Card.OnlineAttendance = this.rowAttendanceData.map((e: any) => e.IsOnlineAttendance).reduce((acc, cur) => acc + cur, 0);
      this.Card.OnlineAttendancePer = ((this.Card.OnlineAttendance * 100) / this.Card.Total).toFixed(2);
      if (isNaN(this.Card.OnlineAttendancePer)) {
        this.Card.OnlineAttendancePer = 0;
      }

      this.Card.Absent = this.Card.Total - (this.Card.Present + this.Card.OnlineAttendance + this.Card.WO);
      this.Card.AbsentPer = ((this.Card.Absent * 100) / this.Card.Total).toFixed(2);
      if (isNaN(this.Card.AbsentPer)) {
        this.Card.AbsentPer = 0;
      }

      this.isApply = false
      this.showGroup();
      this.isDisabled = false;
    } catch (e) {
      this.isApply = false;
      this.isDisabled = false;
    }
  }

  async showGroup() {
    this.isGrouping = true;
    await new Promise(f => setTimeout(f, 500));
    if (this.rowAttendanceData.length == 0) {
      this.rowAttendanceData = JSON.parse(pako.inflate(Uint8Array.from(atob(this.summaryResponse), c => c.charCodeAt(0)), { to: 'string' })).Table.filter((e: never) =>
        (this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.indexOf(e['ESS_ShiftGroupMasterId']) >= 0) &&
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftId']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateId']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchId']) >= 0) &&
        (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.indexOf(e['ClientId']) >= 0) &&
        (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.indexOf(e['SiteId']) >= 0) &&
        (this.mfilter.IndustrySegmentId.length == 0 || this.mfilter.IndustrySegmentId.indexOf(e['IndustrySegmentId']) >= 0) &&
        (this.mfilter.SiteOwnerID.length == 0 || this.mfilter.SiteOwnerID.indexOf(e['SiteSupervisorId']) >= 0) &&
        (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.indexOf(e['ZoneId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0));
    }

    try {
      //First, group the products by category
      let isGraph = false;
      this.filterData = this.rowAttendanceData.reduce((acc: any, curr) => {
        //let key = this.groupby.Site ? curr['SiteId'] : this.groupby.Client ? curr['ClientId'] : this.groupby.Branch ? curr['BranchId'] : this.groupby.Region ? curr['RegionMasterID'] : this.groupby.State ? curr['StateId'] : curr['SiteId'];
        //let keyName = this.groupby.Site ? curr['SiteName'] : this.groupby.Client ? curr['ClientName'] : this.groupby.Branch ? curr['BranchName'] : this.groupby.Region ? curr['RegionName'] : this.groupby.State ? curr['StateName'] : curr['SiteName'];

        let key = '';
        let keyName = '';
        if (this.groupby.Site) { key += curr['SiteId']; keyName += curr['SiteName'] }
        if (this.groupby.Client) { key += curr['ClientId']; keyName += curr['ClientName'] }
        if (this.groupby.Branch) { key += curr['BranchId']; keyName += curr['BranchName'] }
        if (this.groupby.Region) { key += curr['RegionMasterID']; keyName += curr['RegionName'] }
        if (this.groupby.State) { key += curr['StateId']; keyName += curr['StateName'] }

        if (!acc[key + '_' + keyName]) {
          acc[key + '_' + keyName] = [];
          isGraph = true;
        }
        acc[key + '_' + keyName].push(curr);
        return acc;
      }, {});

      if (isGraph && (this.mfilter.filterType == 0 || this.mfilter.filterType == 2 || this.mfilter.filterType == 3 || this.mfilter.filterType == 4)) {
        let uniqDate = this.getDatesInRange(this.filter.FromDate, this.filter.ToDate);

        let AttendanceChartData = [] as any;
        AttendanceChartData.push(
          {
            label: 'Present',
            data: [],
            backgroundColor: ['#4ce2b0'],
          }
        );
        AttendanceChartData.push(
          {
            label: 'Absent',
            data: [],
            backgroundColor: ['#ff4c4c'],
          }
        );
        AttendanceChartData.push(
          {
            label: 'Weekoff',
            data: [],
            backgroundColor: ['#6A0DAD'],
          }
        );

        uniqDate.forEach(element => {
          let totalManpower = 0;
          const _datewise = this.rowAttendanceData.filter((e: any) => new Date(e.AttendanceDate).toISOString() == element.toISOString());
          AttendanceChartData[0].data.push(_datewise.map((e: any) => e.P).reduce((acc, cur) => acc + cur, 0) + _datewise.map((e: any) => e.IsOnlineAttendance).reduce((acc, cur) => acc + cur, 0));
          AttendanceChartData[1].data.push(_datewise.map((e: any) => e.A).reduce((acc, cur) => acc + cur, 0));
          AttendanceChartData[2].data.push(_datewise.map((e: any) => e.WO).reduce((acc, cur) => acc + cur, 0))
        });
        this.AttendanceChartData = {
          labels: uniqDate.map(e => this.datepipe.transform(e, 'dd MMM yyyy')),
          datasets: AttendanceChartData
        };
      } else if (isGraph && (this.mfilter.filterType == 1)) {
        let ChartData = [] as any;
        ChartData.push(
          {
            label: 'Present',
            data: [this.Card.Present + this.Card.OnlineAttendance],
            backgroundColor: ['#4ce2b0'],
          }
        );
        ChartData.push(
          {
            label: 'Absent',
            data: [this.Card.Absent],
            backgroundColor: ['#ff4c4c'],
          }
        );
        ChartData.push(
          {
            label: 'Weekoff',
            data: [this.Card.WO],
            backgroundColor: ['#6A0DAD'],
          }
        );
        this.AttendanceChartData = {
          labels: [this.filter.MonthYear],
          datasets: ChartData,
        };
      } else {
        this.AttendanceChartData = {
          labels: [],
          datasets: []
        };
      }
      this.filterData = Object.values(isGraph ? this.filterData : []);
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.rowAttendanceData = [];
      this.rowAttendanceDataMain = [];
      this.isGrouping = false;
    } catch (e) {
      this.isDisabled = false;
      this.isGrouping = false;
    }
  }


  Sitemanpower(Object: any) {
    return Object.map((e: any) => e.TotalManpowerOfSite).reduce((acc: any, cur: any) => acc + cur, 0); //Object.map((e: any) => e.SiteId + '_' + e.AttendanceDate + '_' + e.TotalManpowerOfSite).filter((value: any, index: any, self: any) => self.indexOf(value) === index).reduce((acc: any, cur: any) => acc + parseInt(cur.split('_')[2]), 0);///Object.map((e:any)=> e.SiteId + '_' + e.AttendanceDate + '_' + e.TotalManpowerOfSite).filter((value:any, index:any, self:any) => self.indexOf(value) === index).length;
  }

  Present(Object: any) {
    return Object.map((e: any) => e.P).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  PresentOnlineAttendance(Object: any) {
    return Object.map((e: any) => e.P + e.IsOnlineAttendance).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  Absent(Object: any) {
    return Object.map((e: any) => e.A).reduce((acc: any, cur: any) => acc + cur, 0);//Object.map((e: any) => e.SiteId + '_' + e.AttendanceDate + '_' + e.TotalManpowerOfSite).filter((value: any, index: any, self: any) => self.indexOf(value) === index).reduce((acc: any, cur: any) => acc + parseInt(cur.split('_')[2]), 0) - Object.filter((e: any) => e.P == 1).length;
  }

  AbsentPer(Object: any) {
    const abp = (this.Absent(Object) * 100) / this.Sitemanpower(Object);
    if (isNaN(abp)) {
      return 0;
    } else {
      return abp;
    }
  }

  Weekoff(Object: any) {
    return Object.map((e: any) => e.WO).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  IsOnlineAttendance(Object: any) {
    return Object.map((e: any) => e.IsOnlineAttendance).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  AttendanceDashboardGetDataEmp() {
    //await new Promise(f => setTimeout(f, 500));
    this.filterEmpData = [] as any;

    this.dashboard.AttendanceDashboardGzipGetData({ MonthYear: this.filter.MonthYear, FromDate: this.filter.FromDate, ToDate: this.filter.ToDate, UserId: this.filter.UserId, Type: 'EmpWise' }).subscribe({
      next: (response) => {
        try {
          const compressedData = Uint8Array.from(atob(response.toString()), c => c.charCodeAt(0));
          // Decompress the Gzip data
          const decompressedData = pako.inflate(compressedData, { to: 'string' });
          this.rowAttendanceDataEmpMain = JSON.parse(decompressedData).Table;
          this.mfilter.EmpDataLoad = true;
        } catch (e) {
          this.isDisabled = false;
          this.isGrouping = false;
          this.isApply = false;
          this.mfilter.EmpDataLoad = true;
        }
      },
      complete: () => {
        this.mfilter.EmpDataLoad = true;
      },
      error: (error) => {
        this.mfilter.EmpDataLoad = true;
      },
    });
  }

  async EmpTableFilter(Type: String, id: number) {
    this.isDisabled = true;
    await new Promise(f => setTimeout(f, 500));
    if (this.rowAttendanceDataEmpMain.length > 0) {
      this.rowAttendanceDataEmp = this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.indexOf(e['ESS_ShiftGroupMasterId']) >= 0) &&
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftId']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateId']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchId']) >= 0) &&
        (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.indexOf(e['ClientId']) >= 0) &&
        (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.indexOf(e['SiteId']) >= 0) &&
        (this.mfilter.IndustrySegmentId.length == 0 || this.mfilter.IndustrySegmentId.indexOf(e['IndustrySegmentId']) >= 0) &&
        (this.mfilter.SiteOwnerID.length == 0 || this.mfilter.SiteOwnerID.indexOf(e['SiteSupervisorId']) >= 0) &&
        (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.indexOf(e['ZoneId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0));

      this.filterEmpData = Object.values([]);
      this.dtElementEmp.dtInstance.then((dtInstance: DataTables.Api) => {
        this.dtTriggerEmp.next(null);
      });

      if (Type == 'State') {
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.StateId == id));
      } else if (Type == 'Region') {
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.RegionMasterID == id));
      } else if (Type == 'Branch') {
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.BranchId == id));
      } else if (Type == 'Department') { //only for back
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.DepartmentMasterID == id));
      } else if (Type == 'Designation') { //only for back
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.DesignationMasterID == id));
      } else if (Type == 'Client') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.ClientId == id));
      } else if (Type == 'Site') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.SiteId == id));
      } else if (Type == 'Absent') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => (this.groupby.Supervisor ? e.SiteSupervisorId == id : this.groupby.Site ? e.SiteId == id : this.groupby.Client ? e.ClientId == id : this.groupby.Branch ? e.BranchId == id : this.groupby.Region ? e.RegionMasterID == id : this.groupby.State ? e.StateId == id : e.SiteSupervisorId == id) && e.A == 1));
      } else if (Type == 'Present') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => (this.groupby.Supervisor ? e.SiteSupervisorId == id : this.groupby.Site ? e.SiteId == id : this.groupby.Client ? e.ClientId == id : this.groupby.Branch ? e.BranchId == id : this.groupby.Region ? e.RegionMasterID == id : this.groupby.State ? e.StateId == id : e.SiteSupervisorId == id) && e.P == 1));
      }

      if (this.filterEmpData.length > 0) {
        try {
          // this.dtElementEmp.dtInstance.then((dtInstance: DataTables.Api) => {
          //   dtInstance.destroy();
          //   this.dtTriggerEmp.unsubscribe();
          //   //this.dtTrigger.next(null);
          //   this.dtTriggerEmp.next(null);
          //   this.dtTriggerEmp.subscribe();
          // });

          this.dtElementEmp.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTriggerEmp.unsubscribe();
            this.dtTrigger.next(null);
            this.dtTriggerEmp.next(null);
            this.dtTriggerEmp.subscribe();
          });
          this.isDisabled = false;
        } catch (e) {
          this.isDisabled = false;
        }
      } else {
        this.toast.show({ message: 'Data not available 1..', type: toastTypeEnum.warning });
      }
      this.Collapsed.EmployeeDetails = true;
      this.isDisabled = false;
    } else {
      if (this.mfilter.EmpDataLoad) {
        this.toast.show({ message: 'Data not available 2..', type: toastTypeEnum.dark });
      } else {
        this.toast.show({ message: 'Data Fetching in Process..', type: toastTypeEnum.dark });
      }
      this.isDisabled = false;
    }
    this.rowAttendanceDataEmp = [];
    //this.rowAttendanceDataEmpMain = [];
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.mfilter.TodayDate = moment(response.Table[0].RegistrationDate);
          this.mfilter.YesterdateDate = moment(response.Table[0].RegistrationDate).add(-1, 'day');
          this.mfilter.FromDate = {
            "year": this.mfilter.TodayDate.year(),
            "month": this.mfilter.TodayDate.month() + 1,
            "day": this.mfilter.TodayDate.date()
          };
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.AttendanceDashboardGetData();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onNavigate(event: any) {
    this.mfilter.FromDate = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  getDatesInRange(startDate: any, endDate: any) {
    const date = new Date(startDate);
    const dates = [];

    while (date <= new Date(endDate)) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }

    return dates;
  }

  // GetCount(Type: string, id: number) {
  //   if (Type == 'Shift') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.ShiftId == id && e.P == 1).length
  //   } else if (Type == 'State') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.StateId == id && e.P == 1).length
  //   } else if (Type == 'Branch') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.BranchId == id && e.P == 1).length
  //   } else if (Type == 'Client') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.ClientId == id && e.P == 1).length
  //   } else if (Type == 'Supervisor') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == id && e.P == 1).length
  //   } else if (Type == 'Site') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.SiteId == id && e.P == 1).length
  //   } else if (Type == 'Department') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.DepartmentId == id && e.P == 1).length
  //   } else if (Type == 'Designation') {
  //     return this.rowAttendanceDataMain.filter((e: any) => e.DesignationId == id && e.P == 1).length
  //   }
  //   return 0;
  // }

  async ExcelDump(id: number) {
    this.excelData = [];
    if (id == 0) {
      if (!this.LoadFlag.Analytics) {
        this.isDisabled = true;
        await new Promise(f => setTimeout(f, 500));

        this.CardOpenClose('CardAnalytics');
        this.filterData = Object.values(this.filterData.length > 0 ? this.filterData : []);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      }
      this.excelData = JSON.parse(JSON.stringify(this.filterData));
      this.excelData.map((e: any) => { e[0].AbsentPer = this.AbsentPer(e).toFixed(2), e[0].TotalManpowerOfSite = this.Sitemanpower(e), e[0].WO = this.Weekoff(e); e[0].IsOnlineAttendance = this.IsOnlineAttendance(e); e[0].P = this.Present(e), e[0].A = this.Absent(e) });
      this.excelData = this.excelData.map((e: any) => e[0]);
      this.excelData.forEach(function (x: any) { delete x.StateId, delete x.BranchId, delete x.RegionMasterID, delete x.ClientId, delete x.SiteId, delete x.SiteSupervisorId, delete x.ZoneId, delete x.ShiftId, delete x.AttendanceDate, delete x.L, delete x.PH, delete x.NH, delete x.ESS_ShiftGroupMasterId });

      if (!this.groupby.State) {
        this.excelData.forEach(function (x: any) { delete x.StateName });
      } if (!this.groupby.Region) {
        this.excelData.forEach(function (x: any) { delete x.RegionName });
      } if (!this.groupby.Branch) {
        this.excelData.forEach(function (x: any) { delete x.BranchName });
      } if (!this.groupby.Client) {
        this.excelData.forEach(function (x: any) { delete x.ClientName });
      } if (!this.groupby.Site) {
        this.excelData.forEach(function (x: any) { delete x.SiteCode, delete x.SiteName });
      } if (!this.groupby.Department) {
        this.excelData.forEach(function (x: any) { delete x.DepartmentName });
      } if (!this.groupby.Designation) {
        this.excelData.forEach(function (x: any) { delete x.DesignationName });
      } if (!this.groupby.Site) {
        this.excelData.forEach(function (x: any) { delete x.SiteSupervisorName });
        this.excelData.forEach(function (x: any) { delete x.SiteStartDate });
        this.excelData.forEach(function (x: any) { delete x.SiteEndDate });
      }
    } else if (id == 1 || id == 3) {
      if (id == 1) {
        this.excelData = JSON.parse(JSON.stringify(this.filterEmpData));
      } else if (id == 3) {
        this.excelData = JSON.parse(JSON.stringify(this.rowAttendanceDataEmpMain));
      }

      this.excelData.forEach(function (x: any) {
        delete x.DailyAttendanceInOutId, delete x.EmpMasterId, delete x.StateId, delete x.BranchId, delete x.RegionMasterID, delete x.ClientId, delete x.SiteId, delete x.IndustrySegmentId, delete x.SiteSupervisorId, delete x.DesignationId, delete x.DepartmentId, delete x.DepartmentName, delete x.ZoneId, delete x.ShiftId, delete x.SiteManpower, delete x.TotalManpowerOfSite, delete x.P, delete x.L, delete x.A, delete x.PH, delete x.NH, delete x.WO, delete x.Leave, delete x.Regularization, delete x.AttendanceApprovalStatus, delete x.ESS_ShiftGroupMasterId
      });
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    if (id == 0 || id == 1 || id == 3) {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelData);
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    } else if (id == 2) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(document.getElementById("summarydatatable"));

      if (!this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled) {
        const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
        const targetColName = "total active";

        let colToRemove = -1;
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });
          const cell = ws[headerCell];
          if (cell?.v && typeof cell.v === 'string' && cell.v.toLowerCase().includes(targetColName)) {
            colToRemove = C;
            break;
          }
        }

        if (colToRemove >= 0) {
          for (let C = colToRemove; C < range.e.c; ++C) {
            for (let R = range.s.r; R <= range.e.r; ++R) {
              const nextCell = XLSX.utils.encode_cell({ r: R, c: C + 1 });
              const currentCell = XLSX.utils.encode_cell({ r: R, c: C });
              ws[currentCell] = ws[nextCell];
            }
          }

          for (let R = range.s.r; R <= range.e.r; ++R) {
            const lastCell = XLSX.utils.encode_cell({ r: R, c: range.e.c });
            delete ws[lastCell];
          }

          range.e.c--;
          ws['!ref'] = XLSX.utils.encode_range(range);
        }
      }

      // Proceed with export
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'ExcelSheet.xlsx');
    }

    if (id != 2) {
      XLSX.writeFile(wb, 'ExcelSheet.xlsx');
    }
  }

  BranchWiseSiteCount(id: number) {
    //return this.rowAttendanceDataMain.filter((e: any) => e.BranchId == id).length;
    return this.rowAttendanceData.filter((e: any) => e.BranchId == id).length;
  }

  BranchWiseSitePunchCount(id: number) {
    //return this.rowAttendanceDataMain.filter((e: any) => e.BranchId == id && e.P > 0).length;
    return this.rowAttendanceData.filter((e: any) => e.BranchId == id && e.P > 0).length;
  }

  BranchWiseSitePendingCount(id: number) {
    return this.BranchWiseSiteCount(id) - this.BranchWiseSitePunchCount(id);
  }

  BranchWiseTotalManpower(id: number) {
    //return this.rowAttendanceDataMain.filter((e: any) => e.BranchId == id).map((e: any) => e.TotalManpowerOfSite).reduce((acc: any, cur: any) => acc + cur, 0);
    return this.rowAttendanceData.filter((e: any) => e.BranchId == id).map((e: any) => e.TotalManpowerOfSite).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  BranchWiseTotalPunchManpower(id: number) {
    //return this.rowAttendanceDataMain.filter((e: any) => e.BranchId == id && e.P > 0).map((e: any) => e.P).reduce((acc: any, cur: any) => acc + cur, 0);
    return this.rowAttendanceData.filter((e: any) => e.BranchId == id && e.P > 0).map((e: any) => e.P).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  BranchWiseTotalPendingManpower(id: number) {
    return this.BranchWiseTotalManpower(id) - this.BranchWiseTotalPunchManpower(id);
  }

  CheckAllGroupBy() {
    if (this.groupby.Checkall) {
      this.groupby.State = true;
      this.groupby.Region = true;
      this.groupby.Branch = true;
      this.groupby.Client = true;
      this.groupby.Site = true;
      this.groupby.Department = true;
      this.groupby.Designation = true;
      this.groupby.Supervisor = false;
    } else {
      this.groupby.State = false;
      this.groupby.Region = false;
      this.groupby.Branch = false;
      this.groupby.Client = false;
      this.groupby.Site = false;
      this.groupby.Department = false;
      this.groupby.Designation = false;
      this.groupby.Supervisor = false;
    }
  }

  DropdownChange(Key: String) {
    if (Key == 'ShiftGroup') {
      this.Shifts = [];
      this.mfilter.ShiftMasterID = [];

      this.ShiftsMap.forEach((shiftData, shiftId) => {
        if (this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => shiftData.ESS_ShiftGroupMasterId.includes(e)).length > 0) {
          this.Shifts.push({
            ShiftMasterID: shiftId,
            ShiftTitle: shiftData.ShiftTitle,
            ShiftInTime: shiftData.ShiftInTime
          });
        }
      });
    }

    if (Key == 'ShiftGroup' || Key == 'Shift') {
      this.Regions = [];
      this.mfilter.RegionMasterID = [];
      this.RegionsMap.forEach((regionData, regionMasterID) => {
        if ((this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => regionData.ESS_ShiftGroupMasterId.includes(e)).length > 0) &&
          (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.filter((e: any) => regionData.ShiftId.includes(e)).length > 0)) {
          this.Regions.push({
            RegionMasterID: regionMasterID,
            RegionName: regionData.RegionName
          });
        }
      });
    }

    if (Key == 'ShiftGroup' || Key == 'Shift' || Key == 'Region') {
      this.Branchs = [];
      this.mfilter.BranchMasterID = [];
      this.BranchsMap.forEach((branchData, branchId) => {
        if ((this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => branchData.ESS_ShiftGroupMasterId.includes(e)).length > 0) &&
          (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.filter((e: any) => branchData.ShiftId.includes(e)).length > 0) &&
          (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.filter((e: any) => branchData.RegionMasterID.includes(e)).length > 0)) {
          this.Branchs.push({
            BranchMasterID: branchId,
            BranchName: branchData.BranchName
          });
        }
      });
    }

    if (Key == 'ShiftGroup' || Key == 'Shift' || Key == 'Region' || Key == 'Branch') {
      this.Clients = [];
      this.mfilter.ClientGroupMasterID = [];
      this.ClientsMap.forEach((clientData, clientId) => {
        if ((this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => clientData.ESS_ShiftGroupMasterId.includes(e)).length > 0) &&
          (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.filter((e: any) => clientData.ShiftId.includes(e)).length > 0) &&
          (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.filter((e: any) => clientData.RegionMasterID.includes(e)).length > 0) &&
          (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.filter((e: any) => clientData.BranchId.includes(e)).length > 0)) {
          this.Clients.push({
            ClientGroupMasterID: clientId,
            ClientGroupName: clientData.ClientName
          });
        }
      });
    }

    if (Key == 'ShiftGroup' || Key == 'Shift' || Key == 'Region' || Key == 'Branch' || Key == 'Client') {
      this.Sites = [];
      this.mfilter.SiteMasterID = [];
      this.SitesMap.forEach((siteData, siteId) => {
        if ((this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => siteData.ESS_ShiftGroupMasterId.includes(e)).length > 0) &&
          (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.filter((e: any) => siteData.ShiftId.includes(e)).length > 0) &&
          (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.filter((e: any) => siteData.RegionMasterID.includes(e)).length > 0) &&
          (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.filter((e: any) => siteData.BranchId.includes(e)).length > 0) &&
          (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.filter((e: any) => siteData.ClientId.includes(e)).length > 0)) {
          this.Sites.push({
            SiteMasterID: siteId,
            SiteName: siteData.SiteName
          });
        }
      });
    }

    if (Key == 'ShiftGroup' || Key == 'Shift' || Key == 'Region' || Key == 'Branch' || Key == 'Client' || Key == 'Site') {
      this.SiteOwners = [];
      this.IndustrySegments = [];

      this.mfilter.SiteOwnerID = [];
      this.mfilter.IndustrySegmentId = [];

      this.SiteOwnersMap.forEach((siteSupervisorData, siteSupervisorId) => {
        if ((this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => siteSupervisorData.ESS_ShiftGroupMasterId.includes(e)).length > 0) &&
          (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.filter((e: any) => siteSupervisorData.ShiftId.includes(e)).length > 0) &&
          (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.filter((e: any) => siteSupervisorData.RegionMasterID.includes(e)).length > 0) &&
          (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.filter((e: any) => siteSupervisorData.BranchId.includes(e)).length > 0) &&
          (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.filter((e: any) => siteSupervisorData.ClientId.includes(e)).length > 0) &&
          (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.filter((e: any) => siteSupervisorData.SiteId.includes(e)).length > 0)) {
          this.SiteOwners.push({
            SiteOwnerID: siteSupervisorId,
            SiteOwnerName: siteSupervisorData.SiteSupervisorName
          });
        }
      });

      this.IndustrySegmentsMap.forEach((industrySegmentData, industrySegmentId) => {
        if ((this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => industrySegmentData.ESS_ShiftGroupMasterId.includes(e)).length > 0) &&
          (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.filter((e: any) => industrySegmentData.ShiftId.includes(e)).length > 0) &&
          (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.filter((e: any) => industrySegmentData.RegionMasterID.includes(e)).length > 0) &&
          (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.filter((e: any) => industrySegmentData.BranchId.includes(e)).length > 0) &&
          (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.filter((e: any) => industrySegmentData.ClientId.includes(e)).length > 0) &&
          (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.filter((e: any) => industrySegmentData.SiteId.includes(e)).length > 0)) {
          this.IndustrySegments.push({
            IndustrySegmentId: industrySegmentId,
            IndustrySegmentName: industrySegmentData.IndustrySegmentName
          });
        }
      });
    }
    // if(this.rowAttendanceDataMain.length == 0){
    //   this.rowAttendanceDataMain = this.summaryResponse.Table;
    // }

    // if (Key == 'State') {
    //   this.Branchs = [];
    //   this.mfilter.BranchMasterID = [];

    //   [...new Set(this.rowAttendanceDataMain.filter(e => (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.includes(e['StateId']))).map((item: any) => item.BranchId))].filter(e => e != null).forEach(element => {
    //     this.Branchs.push({
    //       BranchMasterID: element,
    //       BranchName: this.rowAttendanceDataMain.filter((e: any) => e.BranchId == element)[0]['BranchName']
    //     })
    //   });
    // }

    // if (Key == 'State' || Key == 'Branch') {
    //   this.Zones = [];
    //   this.mfilter.ZoneID = [];

    //   [...new Set(this.rowAttendanceDataMain.filter(e => (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.includes(e['StateId'])) && (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.includes(e['BranchId']))).map((item: any) => item.ZoneId))].filter(e => e != null).forEach(element => {
    //     this.Zones.push({
    //       ZoneID: element,
    //       ZoneName: this.rowAttendanceDataMain.filter((e: any) => e.ZoneId == element)[0]['ZoneName']
    //     })
    //   });
    // }

    // if (Key == 'State' || Key == 'Branch' || Key == 'Zone') {
    //   this.Clients = [];
    //   this.mfilter.ClientGroupMasterID = [];

    //   [...new Set(this.rowAttendanceDataMain.filter(e => (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.includes(e['StateId'])) && (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.includes(e['BranchId'])) && (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.includes(e['ZoneId']))).map((item: any) => item.ClientId))].filter(e => e != null).forEach(element => {
    //     this.Clients.push({
    //       ClientGroupMasterID: element,
    //       ClientGroupName: this.rowAttendanceDataMain.filter((e: any) => e.ClientId == element)[0]['ClientName']
    //     })
    //   });
    // }
    // if (Key == 'State' || Key == 'Branch' || Key == 'Zone' || Key == 'Client') {
    //   this.Sites = [];
    //   this.mfilter.SiteMasterID = [];

    //   [...new Set(this.rowAttendanceDataMain.filter(e => (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.includes(e['StateId'])) && (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.includes(e['BranchId'])) && (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.includes(e['ZoneId'])) && (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.includes(e['ClientId']))).map((item: any) => item.SiteId))].filter(e => e != null).forEach(element => {
    //     this.Sites.push({
    //       SiteMasterID: element,
    //       SiteName: this.rowAttendanceDataMain.filter((e: any) => e.SiteId == element)[0]['SiteName']
    //     })
    //   });
    // }
    // if (Key == 'State' || Key == 'Branch' || Key == 'Zone' || Key == 'Client' || Key == 'Site') {
    //   this.SiteOwners = [];
    //   this.mfilter.SiteOwnerID = [];

    //   [...new Set(this.rowAttendanceDataMain.filter(e => (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.includes(e['StateId'])) && (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.includes(e['BranchId'])) && (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.includes(e['ZoneId'])) && (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.includes(e['ClientId'])) && (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.includes(e['SiteId']))).map((item: any) => item.SiteSupervisorId))].filter(e => e != null).forEach(element => {
    //     this.SiteOwners.push({
    //       SiteOwnerID: element,
    //       SiteOwnerName: this.rowAttendanceDataMain.filter((e: any) => e.SiteSupervisorId == element)[0]['SiteSupervisorName']
    //     })
    //   });
    // }

    // this.rowAttendanceDataMain = [];
  }

  async CardOpenClose(flag: String) {
    try {
      this.isDisabled = true;
      this.rowAttendanceData = JSON.parse(pako.inflate(Uint8Array.from(atob(this.summaryResponse), c => c.charCodeAt(0)), { to: 'string' })).Table.filter((e: never) =>
        (this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.indexOf(e['ESS_ShiftGroupMasterId']) >= 0) &&
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftId']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateId']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchId']) >= 0) &&
        (this.mfilter.ClientGroupMasterID.length == 0 || this.mfilter.ClientGroupMasterID.indexOf(e['ClientId']) >= 0) &&
        (this.mfilter.SiteMasterID.length == 0 || this.mfilter.SiteMasterID.indexOf(e['SiteId']) >= 0) &&
        (this.mfilter.IndustrySegmentId.length == 0 || this.mfilter.IndustrySegmentId.indexOf(e['IndustrySegmentId']) >= 0) &&
        (this.mfilter.SiteOwnerID.length == 0 || this.mfilter.SiteOwnerID.indexOf(e['SiteSupervisorId']) >= 0) &&
        (this.mfilter.ZoneID.length == 0 || this.mfilter.ZoneID.indexOf(e['ZoneId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0));

      if (flag == 'CardBranchGraph') {
        if (!this.LoadFlag.BranchGraph && this.Collapsed.BranchGraph) {
          this.isDisabled = true;
          await new Promise(f => setTimeout(f, 500));

          this.LoadFlag.BranchGraph = true;

          const Lb = [] as any
          const BPData = [] as any;
          const BAData = [] as any;
          const BWOData = [] as any;
          [...new Set(this.rowAttendanceData.map((e: any) => e.BranchId))].forEach((element: any) => {
            const _branchData = this.rowAttendanceData.filter((e: any) => e.BranchId == element)
            Lb.push(_branchData[0]['BranchName']);
            BPData.push(_branchData.map((e: any) => e.P).reduce((acc, cur) => acc + cur, 0) + _branchData.map((e: any) => e.IsOnlineAttendance).reduce((acc, cur) => acc + cur, 0));
            BWOData.push(_branchData.map((e: any) => e.WO).reduce((acc, cur) => acc + cur, 0));
            BAData.push(_branchData.map((e: any) => e.A).reduce((acc, cur) => acc + cur, 0));
          });
          this.BranchChartData.labels = Lb;
          this.BranchChartData = {
            labels: Lb,
            datasets: [{
              label: 'Present',
              data: BPData,
              borderColor: ['#4ce2b0'],
              //pointBorderColor: ['#4ce2b0'],
              //pointBackgroundColor: ['#4ce2b0'],
              backgroundColor: ['#4ce2b0'],
              //fill:'start'
            },
            {
              label: 'Absent',
              data: BAData,
              borderColor: ['#ff4c4c'],
              //pointBorderColor: ['#ff4c4c'],
              //pointBackgroundColor: ['#ff4c4c'],
              backgroundColor: ['#ff4c4c'],
              //fill:'start'
            },
            {
              label: 'Weekoff',
              data: BWOData,
              borderColor: ['#6A0DAD'],
              //pointBorderColor: ['#ff4c4c'],
              //pointBackgroundColor: ['#ff4c4c'],
              backgroundColor: ['#6A0DAD'],
              //fill:'start'
            }
            ],
          };
          this.isDisabled = false;
        }
      } else if (flag == 'CardAnalytics') {
        if (!this.LoadFlag.Analytics && this.Collapsed.AttendanceAnalytics) {
          this.isDisabled = true;
          await new Promise(f => setTimeout(f, 500));

          this.LoadFlag.Analytics = true;
          let isGraph = false;
          this.filterData = this.rowAttendanceData.reduce((acc: any, curr) => {
            //let key = this.groupby.Site ? curr['SiteId'] : this.groupby.Client ? curr['ClientId'] : this.groupby.Branch ? curr['BranchId'] : this.groupby.Region ? curr['RegionMasterID'] : this.groupby.State ? curr['StateId'] : curr['SiteId'];
            //let keyName = this.groupby.Site ? curr['SiteName'] : this.groupby.Client ? curr['ClientName'] : this.groupby.Branch ? curr['BranchName'] : this.groupby.Region ? curr['RegionName'] : this.groupby.State ? curr['StateName'] : curr['SiteName'];

            let key = '';
            let keyName = '';
            if (this.groupby.Site) { key += curr['SiteId']; keyName += curr['SiteName'] }
            if (this.groupby.Client) { key += curr['ClientId']; keyName += curr['ClientName'] }
            if (this.groupby.Branch) { key += curr['BranchId']; keyName += curr['BranchName'] }
            if (this.groupby.Region) { key += curr['RegionMasterID']; keyName += curr['RegionName'] }
            if (this.groupby.State) { key += curr['StateId']; keyName += curr['StateName'] }

            if (!acc[key + '_' + keyName]) {
              acc[key + '_' + keyName] = [];
              isGraph = true;
            }
            acc[key + '_' + keyName].push(curr);
            return acc;
          }, {});

          this.filterData = Object.values(isGraph ? this.filterData : []);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        }
      }
      this.rowAttendanceData = [];
      this.isDisabled = false;
    } catch (e) {
      this.isDisabled = false;
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  timeToMinutes(time: string): number {
    if (time === '' || time == undefined) {
      return -1; // Treat empty time as the earliest (i.e., place it at the top)
    } else {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes; // Convert to total minutes since midnight
    }
  }

  ESS_CentralizedLoginKeyGeneration() {
    this.isDisabled = true;
    return this.utility.ESS_CentralizedLoginKeyGeneration({ 'SelectType': 'I', 'ModuleName': 'administrator', 'JSON': JSON.stringify(this.session.GetUserDetails()) }).subscribe({
      next: (response) => {
        if (response.Error_Code == '01' && response.Key != null && response.Key != '') {
          console.log("https://localhost:4660/Login/" + response.Key);
          //window.open("https://localhost:4660/Login/" + response.Key, "_black");
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.AttendanceDashboardGetData();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CheckAll(event: any, Type: String) {
    if (Type == 'ShiftGroup') {
      if (event.target.checked) {
        this.mfilter.ShiftGroupMasterID = this.ShiftGroups.map((e: any) => e.ShiftGroupMasterID);
      } else {
        this.mfilter.ShiftGroupMasterID = [];
      }
    } else if (Type == 'Shift') {
      if (event.target.checked) {
        this.mfilter.ShiftMasterID = this.Shifts.map((e: any) => e.ShiftMasterID);
      } else {
        this.mfilter.ShiftMasterID = [];
      }
    } else if (Type == 'Region') {
      if (event.target.checked) {
        this.mfilter.RegionMasterID = this.Regions.map((e: any) => e.RegionMasterID);
      } else {
        this.mfilter.RegionMasterID = [];
      }
    } else if (Type == 'Branch') {
      if (event.target.checked) {
        this.mfilter.BranchMasterID = this.Branchs.map((e: any) => e.BranchMasterID);
      } else {
        this.mfilter.BranchMasterID = [];
      }
    } else if (Type == 'Client') {
      if (event.target.checked) {
        this.mfilter.ClientGroupMasterID = this.Clients.map((e: any) => e.ClientGroupMasterID);
      } else {
        this.mfilter.ClientGroupMasterID = [];
      }
    } else if (Type == 'Site') {
      if (event.target.checked) {
        this.mfilter.SiteMasterID = this.Sites.map((e: any) => e.SiteMasterID);
      } else {
        this.mfilter.SiteMasterID = [];
      }
    } else if (Type == 'SiteOwner') {
      if (event.target.checked) {
        this.mfilter.SiteOwnerID = this.SiteOwners.map((e: any) => e.SiteOwnerID);
      } else {
        this.mfilter.SiteOwnerID = [];
      }
    } else if (Type == 'IndustrySegment') {
      if (event.target.checked) {
        this.mfilter.IndustrySegmentId = this.IndustrySegments.map((e: any) => e.IndustrySegmentId);
      } else {
        this.mfilter.IndustrySegmentId = [];
      }
    }
  }

  getDeviceList(deviceInfo: string): any[] {
    if (!deviceInfo) return [];

    const devices = deviceInfo.split(',');
    const deviceList = [];

    for (const device of devices) {
      const parts = device.split('-');
      if (parts.length === 2) {
        deviceList.push({
          serial: parts[0].trim(),
          status: parts[1].trim()
        });
      }
    }

    return deviceList;
  }

  GotoDevice(serial: string) {
    if (this.allowRedirectDevice) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to redirect on device page?';
      modalRef.componentInstance.Button1 = 'Yes';
      modalRef.result.then(result => {
        if (result) {
          this.router.navigate([]).then(result => { window.open(`attendancedevice/device/deviceattendance/${serial}`, '_blank'); });
        }
      });
    }
  }

  AllowRedirectOnDeivce() {
    this.userright.ESS_ProfileMenuRightsView({ SelectType: 'GetRights', ESS_MenuMasterId: 342 }).subscribe({
      next: (response) => {
        if (response.Table && response.Table.length > 0) {
          this.allowRedirectDevice = true;
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

}